import type { AppField } from "@smartsuite/smartsuite-client";
import { t } from "i18next";

export const getStructure = (): AppField[] => [
  {
    slug: "datetime",
    label: t("automation-activity.startedLabel"),
    field_type: "datefield",
    icon: "",
    params: {
      required: false,
      unique: false,
      hidden: false,
      help_text: "",
      placeholder: "Select Date Range",
      default_value: null,
      width: 1,
      system: false,
      valid: true,
      is_migrating: false,
      display_format: "long",
    },
    nested: [],
  },
  {
    slug: "status",
    label: t("automation-activity.statusLabel"),
    field_type: "statusfield",
    icon: "",
    params: {
      choices: [
        {
          label: "Success",
          value: "is_success",
          value_color: "#3EAC40",
          value_order: 0,
          is_complete: false,
        },
        {
          label: "Erorr",
          value: "is_error",
          value_color: "#FF5757",
          value_order: 1,
          is_complete: true,
        },
      ],
      required: false,
      unique: false,
      hidden: false,
      help_text: "",
      placeholder: "",
      default_value: {
        value: "is_success",
        updated_on: null,
      },
      width: 1,
      system: false,
      valid: true,
      is_migrating: false,
    },
    nested: [],
  },
  {
    slug: "duration",
    label: t("automation-activity.durationLabel"),
    field_type: "durationfield",
    params: {
      display_format: "long",
      duration_format: "hh:mm:ss",
      placeholder: "Type minutes, hours or days",
      required: false,
      unique: false,
      hidden: false,
      help_text: "",
      default_value: null,
      width: 1,
      system: false,
      valid: true,
      is_migrating: false,
    },
  },
  {
    slug: "actions",
    label: t("automation-activity.actionsLabel"),
    field_type: "textfield",
    params: {
      primary: false,
      max_length: undefined,
      required: false,
      unique: false,
      hidden: false,
      help_text: "",
      placeholder: "Write here",
      default_value: null,
      width: 1,
      system: false,
      valid: true,
      is_migrating: false,
    },
  },
];

export const defaultColumnsWidths = {
  datetime: 255,
  status: 162,
  duration: 162,
  actions: 162,
};
